import styled from 'styled-components'

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 38px 20px;
  text-align: center;
`

export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: #cccccc;
`

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a1a;
  margin: 0 0 10px 0;
`

export const Description = styled.p`
  font-size: 13px;
  line-height: 1.5;
  color: #666666;
  margin: 0 0 26px 0;
  max-width: 320px;
`
